'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var PropTypes = _interopDefault(require('prop-types'));
var React = require('react');
var React__default = _interopDefault(React);
var __chunk_1 = require('./_virtual/_rollupPluginBabelHelpers.js');

var TimestampContext = React__default.createContext(0);
/**
 * Timestamp context provider. Must be present to make `<Timestamp>` component
 * work.
 *
 * @param {Object} props
 * @param {*} children
 * @param {number} [interval=1000] Context update interval in milliseconds
 * @return {ReactComponent}
 * @example
 * <TimestampProvider interval="5000">
 *   <App />
 * </Timestamp>
 */

var TimestampProvider =
/*#__PURE__*/
function (_React$PureComponent) {
  __chunk_1.inherits(TimestampProvider, _React$PureComponent);

  function TimestampProvider(props) {
    var _this;

    __chunk_1.classCallCheck(this, TimestampProvider);

    _this = __chunk_1.possibleConstructorReturn(this, __chunk_1.getPrototypeOf(TimestampProvider).call(this, props));
    _this.state = {
      timestamp: Date.now()
    };
    return _this;
  }

  __chunk_1.createClass(TimestampProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.timerId = window.setInterval(function () {
        return _this2.setState({
          timestamp: Date.now()
        });
      }, parseInt(this.props.interval, 10));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.clearInterval(this.timerId);
    }
  }, {
    key: "render",
    value: function render() {
      return React__default.createElement(TimestampContext.Provider, {
        value: this.state.timestamp
      }, this.props.children);
    }
  }]);

  return TimestampProvider;
}(React__default.PureComponent);
TimestampProvider.defaultProps = {
  interval: 1000
};
TimestampProvider.propTypes = {
  children: PropTypes.node,
  interval: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  /**
   * Timestamp context consumer. Requires `<TimestampProvider>` to work.
   *
   * @name Timestamp
   * @param {Object} props
   * @param {*} children
   * @param {number} [interval=1000] Children rerender interval in milliseconds
   * @return {ReactComponent}
   * @example
   * <Timestamp interval="60000">
   *   {timestamp => <span>Updates every minute: {timestamp}</span>}
   * </Timestamp>
   */

};
function Timestamp(props) {
  var interval = parseInt(props.interval, 10);
  return React__default.createElement(TimestampContext.Consumer, null, function (timestamp) {
    return props.children(Math.floor(timestamp / interval) * interval);
  });
}
Timestamp.defaultProps = {
  interval: 1000
};
Timestamp.propTypes = {
  children: PropTypes.func,
  interval: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  /**
   * Higher-order component to inject timestamp into wrapped component. Requires `<TimestampProvider>` to work.
   * @param {object} [options]
   * @param {number|Function} [options.interval=1000] Minimum interval to wait before updating
   * @param {ReactComponent} Component
   * @returns {ReactComponent} Wrapped component with `timestamp` prop injected
   */

};
function withTimestamp() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var Component = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof Component === 'undefined') {
    return function (Component) {
      return withTimestamp(options, Component);
    };
  } // eslint-disable-next-line react/display-name


  return function (props) {
    return React__default.createElement(Timestamp, {
      interval: options.interval
    }, function (timestamp) {
      return React__default.createElement(Component, __chunk_1.extends({
        timestamp: timestamp
      }, props));
    });
  };
}

exports.Timestamp = Timestamp;
exports.TimestampContext = TimestampContext;
exports.TimestampProvider = TimestampProvider;
exports.withTimestamp = withTimestamp;
//# sourceMappingURL=timestamp.js.map
